module.exports = __webpack_public_path__ + "static/Joghurt-Kirsch-189f3c3a450763430921eabfa1d43306.png";